module.exports = __webpack_public_path__ + "img/participant-list-desktop-ru.0784ce51.jpg";